import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';

declare const _$: any;
@Component({
  standalone: false,
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  COMMONSERVICE!: BehaviorSubject<any>;
  INPUTVALIDATIONMETHOD: any;
  EXCEL_COLUMNS?: { header: string; field: string }[];
  private readonly FINGERPRINT_ROLE_IDS = [447, 448];
  private readonly EPP_ADMIN_ROLE_IDS = [472];
  private readonly LEA_ADMIN_ROLE_IDS = [446];
  private readonly FINGERPRINT_ADMIN_EXPORT_FIELDS = ['cd_suffix', 'organization', 'recovery_email'];
  private readonly EPP_ADMIN_EXPORT_FIELDS = ['cd_suffix', 'provider', 'recovery_email'];
  private readonly LEA_ADMIN_EXPORT_FIELDS = ['cd_suffix', 'organization', 'recovery_email'];
  private readonly EXCLUDED_EXPORT_FIELDS = ['cd_role_type', 'is_legacy_user'];
  private readonly STATIC_EXCEL_COLUMNS: { header: string; field: string }[] = [
    { header: 'First Name', field: 'firstname' },
    { header: 'Middle Name', field: 'middlename' },
    { header: 'Last Name', field: 'lastname' },
    { header: 'Email', field: 'email' },
    { header: 'Username', field: 'username' },
  ];

  constructor(private permissionStore: PermissionStore, private authService: AuthService, private httpService: HttpService, private sessionStorage: LocalService) {
    console.log('Muthamizh UsersComponent constructor');
    this.COMMONSERVICE = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('ManagementGroupsComponent');
      this.INPUTVALIDATIONMETHOD = AppConstants.onInput.bind(this);
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
    });
    this.COMMONSERVICE.next({
      httpService: this.httpService,
      INPUTVALIDATIONMETHOD: this.INPUTVALIDATIONMETHOD
    })
  }

  ngOnInit(): void {
    this.EXCEL_COLUMNS = this.buildExcelColumns();
    console.log();
  }

  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }

  private buildExcelColumns(): { header: string; field: string }[] | undefined {
    const loggedRoleId = sessionStorage.getItem('role_id');
    let additionalFieldKeys: string[] | undefined;

    if (this.FINGERPRINT_ROLE_IDS.includes(Number(loggedRoleId))) {
      additionalFieldKeys = this.filterExcludedExportFields(this.FINGERPRINT_ADMIN_EXPORT_FIELDS);
    } else if (this.EPP_ADMIN_ROLE_IDS.includes(Number(loggedRoleId))) {
      additionalFieldKeys = this.filterExcludedExportFields(this.EPP_ADMIN_EXPORT_FIELDS);
    } else if (this.LEA_ADMIN_ROLE_IDS.includes(Number(loggedRoleId))) {
      additionalFieldKeys = this.filterExcludedExportFields(this.LEA_ADMIN_EXPORT_FIELDS);
    }

    if (!additionalFieldKeys) {
      return undefined;
    }

    return [
      ...this.STATIC_EXCEL_COLUMNS,
      ...additionalFieldKeys.map(key => ({
        header: key,
        field: `additionalFields.${key}`
      }))
    ];
  }

  private filterExcludedExportFields(fields: string[]): string[] {
    return fields.filter(key => !this.EXCLUDED_EXPORT_FIELDS.includes(key));
  }
}
